import React, { useState } from "react";
import "./styles.scss";
import { Modal, Backdrop } from "@mui/material";

import { useStateValue } from "../../../store";

const EmailPopup = () => {
  const [{ helpingPopup }, dispatch] = useStateValue();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    dispatch({
      type: "SET_IS_HELPING",
      value: false,
    });
  };
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      onClose={handleClose}
      disableAutoFocus={true}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className="help-popup-container"
    >
      <div className="popup-container">
        <h3>Contact Info</h3>
        <div className="section">
          <div>
            <label>Toll free:</label>
            <span>{helpingPopup?.data?.tollfree_number}</span>
          </div>
          <div>
            <label>Email:</label>
            <span>{helpingPopup?.data?.email_input}</span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EmailPopup;
